/// <reference path="../../types/videojs.d.ts"/>
import VideoJsPluginComponent from "./plugin";
function VideoJsPlugin(option) {
    if (!videojs)
        return;
    var player = this;
    var childElement = document.createElement("div");
    var div = document.getElementById(player.id()) || document.createElement("div");
    div.appendChild(childElement);
    var plugin = new VideoJsPluginComponent(player, option, childElement);
    player.on('ready', function () {
        plugin.setup();
    });
    var checkForFirstTime = true;
    player.on('firstplay', function () {
        if (checkForFirstTime) {
            checkForFirstTime = false;
            plugin.showStartLinearAd();
        }
    });
}
if (videojs)
    videojs.plugin("vast", VideoJsPlugin);
export default VideoJsPlugin;
//# sourceMappingURL=index.js.map